export class ArbolCoas {
    codigo_principal: string;
    codigo_Secundario: string;
    descripcion: string;
    tipo: string;
    gestiona: string[];
}


// WEBPACK FOOTER //
// ./src/app/models/ArbolCoas.ts